import { LocaleData } from '../locales';

export class CookiesConsent {
    private container: HTMLDivElement;

    constructor(
        private options: {
            t: (key: keyof LocaleData) => string;
            direction?: 'ltr' | 'rtl';
            onOpenPolicy: () => void;
        }
    ) {
        this.container = document.createElement('div');
        this.container.className = 'cookie-consent-container';
        if (this.options.direction) {
            this.container.dir = this.options.direction;
        }

        const text = document.createElement('p');
        text.className = 'cookie-text';
        text.textContent = this.options.t('cookie_consent_text');
        this.container.appendChild(text);

        const actions = document.createElement('div');
        actions.style.marginTop = '0px';
        actions.style.display = 'flex';
        actions.style.justifyContent = 'center';
        actions.style.gap = '20px';
        actions.style.alignItems = 'center';

        const policyLink = document.createElement('a');
        policyLink.href = '/cookies.html';
        policyLink.className = 'cookie-policy-link';
        policyLink.textContent = this.options.t('read_policy');
        policyLink.onclick = (e) => {
            e.preventDefault();
            this.options.onOpenPolicy();
            this.hide();
        };
        actions.appendChild(policyLink);

        const okBtn = document.createElement('button');
        okBtn.textContent = 'OK';
        okBtn.className = 'cookie-ok-btn';
        okBtn.onclick = () => this.hide();
        actions.appendChild(okBtn);

        this.container.appendChild(actions);

        // Auto show after delay
        setTimeout(() => this.show(), 1000);
    }

    private show() {
        this.container.classList.add('animate');
        document.body.appendChild(this.container);
    }

    private hide() {
        this.container.classList.remove('animate');
        setTimeout(() => this.container.remove(), 500);
    }

    public getElement() {
        return this.container;
    }
}
